import { render, staticRenderFns } from "./AwaitingShipmentOrder.vue?vue&type=template&id=f8fde5ce&scoped=true&"
import script from "./AwaitingShipmentOrder.vue?vue&type=script&lang=js&"
export * from "./AwaitingShipmentOrder.vue?vue&type=script&lang=js&"
import style0 from "./AwaitingShipmentOrder.vue?vue&type=style&index=0&id=f8fde5ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8fde5ce",
  null
  
)

export default component.exports